import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import HtmlEditor, {
  TableContextMenu,
  TableResizing,
  Toolbar,
  Item,
} from "devextreme-react/html-editor";
import {
  GetApp as IconExport,
  LocationCityOutlined,
} from "@mui/icons-material";
import {
  Close as IconClose,
  Edit as IconEdit,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import ConfirmDialog from "components/Custom/ConfirmDialog";
import RichTxtBox from "components/Custom/RichTxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import TxtBox from "components/Custom/TxtBox";

import { NOTIFY, DEFAULTS, FORMATS, CONFIG, API_CONFIG } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  CONFIRMS,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import ExcelGrid from "components/Custom/ExcelGrid";
import UiDialog from "components/Custom/UiDialog";
import { ApiIndents } from "apihandlers/indent";
import { ApiMasters } from "apihandlers/masters/masters";
import { ApiReports } from "apihandlers/reports";
import Loader from "components/Custom/Loader";

const ApiIndentHandler = new ApiIndents();
const ApiReportsHandler = new ApiReports();

const thumbnailImg = require("assets/images/pdf.png");

const DeliveryCommentsReport = (props: any) => {
  const tripsRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>([]);
  const [manageDialog, setManageDialog] = useState(false);
  const [deliveryFiles, setDeliveryFiles] = useState<any>({});
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [trips, setTrips] = useState<any>(null);
  const [history, setHistory] = useState<any>(null);
  const [apiArgs, setApiArgs] = useState<any>({});
  const [markup, setMarkup] = useState("<br/>");
  const [historyId, setHistoryId] = useState("");
  const [htmlLoading, setHtmlLoading] = useState(false);
  const [points, setPoints] = useState<any>([]);
  const [exportName, setExportName] = useState("");

  const jRef = useRef(null);

  const options = {
    data: [[]],
    minDimensions: [10, 10],
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      frozen: true,
    },
    {
      key: "fromLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FROM,
      width: "15%",
      frozen: true,
    },
    {
      key: "toLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TO,
      width: "15%",
      frozen: true,
    },
    {
      key: "tripNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TRIP_NO,
      width: "15%",
    },
    {
      key: "tripDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TRIP_DATE,
      width: "15%",
    },
    {
      key: "vehicleNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "15%",
    },
    {
      key: "driverName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_NAME,
      width: "15%",
    },
    {
      key: "driverNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_MOBILE_NO,
      width: "15%",
    },
    {
      key: "dealerName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DEALER_NAME,
      width: "20%",
    },
    {
      key: "comments",
      type: "htmltext",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DELIVERY_COMMENTS,
      width: "30%",
    },
    {
      key: "inTime",
      type: "datetime",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.IN_TIME,
      width: "10%",
    },
    {
      key: "outTime",
      type: "datetime",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OUT_TIME,
      width: "10%",
    },
    {
      key: "totalDuration",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TOTAL_DURATION,
      width: "10%",
    },
    {
      key: "files",
      type: "html",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.POD,
      width: "30%",
    },
  ];

  useEffect(() => {
    if (loading) {
      getTrips();
    }
  }, []);

  const getTrips = async () => {
    const args = { activeStatus: "true", minResponse: true };
    const res: any = await ApiIndentHandler.getTrips(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.indentNo,
        };
      });
      setTrips(list);
      setLoading(false);
    }
  };

  const reloadGrid = () => {
    onChangeTrip();
  };

  const onChangeTrip = () => {
    const indentId = tripsRef.current.selectedValue.id;
    const trip = tripsRef.current.selectedValue.label;
    setExportName(LABELS.TRIP + ": " + trip);
    const args = {
      tripId: indentId,
      reportType: "excel",
    };
    setRows(null);
    ApiReportsHandler.getDeliveryCommentsReport(args).then((res: any) => {
      if (res.status === 200) {
        const list = res.response.rows;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          const files = [];
          for (let j = 0; j < list[i].pods.length; j++) {
            const filePath = list[i].pods[j].filePath;
            const mimeType = list[i].pods[j].mimeType;
            let fileUrl = API_CONFIG.STATIC_URL + filePath;
            if (mimeType.indexOf("pdf") > -1) {
              fileUrl = thumbnailImg;
            }
            files.push(fileUrl);
          }
          list[i].files = (
            <div className="flexRow">
              {files.map((fileUrl) => {
                return (
                  <div>
                    <img
                      src={fileUrl}
                      alt=""
                      width={"auto"}
                      height={50}
                      onClick={() => {
                        window.open(fileUrl, "_blank");
                      }}
                    />
                  </div>
                );
              })}
            </div>
          );
        }
        setRows(list);
      }
    });
  };

  console.log("rows:", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DELIVERY_COMMENTS_REPORT}</li>
        </ul>
        <h4>{TITLES.DELIVERY_COMMENTS_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.DELIVERY_COMMENTS_REPORT}</p>
      </div>

      <div className="formGroup" style={{ width: "100%" }}>
        <label>{LABELS.SELECT_TRIP}</label>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{ width: "30%", marginRight: 10 }}>
            <AutoComplete
              id={"trips"}
              list={trips}
              childRef={tripsRef}
              defaultValue={
                selectedRow.indentId ? selectedRow.indentGroup : null
              }
              onChange={onChangeTrip}
            />
          </div>
        </div>
      </div>
      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"deliveryCommentsReport"}
            title={LABELS.DELIVERY_COMMENTS_REPORT}
            height={window.innerHeight * 0.7}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={exportName}
            onReload={reloadGrid}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withSnackbar(DeliveryCommentsReport);
